import React, { useState } from "react";
import { Modal as AntModal, Button, message, Space } from "antd";
import styled from "styled-components";
import { IconTrash } from "@assets";
import api from "../../../../../api/api";
import { useTranslation } from "react-i18next";

const Modal = styled(AntModal)`
  .ant-modal-close-icon svg {
    font-size: 24px;
  }

  .ant-modal-title {
    color: #1e1e1e;
    font-size: 24px;
    font-weight: 700;
  }

  .ant-modal-body {
    font-size: 16px;
    font-weight: 400;
    color: #1d1014;
  }

  .ant-modal-footer {
    .ant-btn {
      width: 100%;
      height: 56px;
    }

    .ant-btn-primary {
      background: #f00 !important;
    }

    .ant-space {
      width: 100%;
      gap: 16px !important;

      .ant-space-item {
        flex: 1;
      }
    }
  }
`;

const DeleteModal = ({ id, open, handleClose, successCallback }) => {
  const [loading, setLoading] = useState(false);

  const handleDelete = () => {
    if (!loading) {
      setLoading(true);
      api
        .deletePayment(id)
        .then(() => {
          setLoading(false);
          message.success("Deleted the payment account successfully!");
          handleClose();
          successCallback(id);
        })
        .catch((error) => {
          setLoading(false);
          message.error(error);
        });
    }
  };

  const onCancel = () => {
    !loading && handleClose();
  };
  
  const {t} = useTranslation();

  return (
    <Modal
      centered
      width={500}
      open={open}
      onCancel={onCancel}
      title="Delete Payment Account?"
      footer={
        <Space>
          <Button type="default" onClick={onCancel}>
            {t('cancel')}
          </Button>
          <Button type="primary" icon={<IconTrash />} onClick={handleDelete}>
            {t('delete')}
          </Button>
        </Space>
      }
    >
      {t('cannot_be_undo')}
    </Modal>
  );
};

export default DeleteModal;
